import { Pagination } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Paginate = ({ pages = 1, page = 1, isAdmin = false, keyword = '' }) => {
  // preserve existing query like ?category=Brake%20Discs
  const { search } = useLocation();
  const qs = search || '';

  if (pages <= 1) return null;

  const makeHref = (n) => {
    if (!isAdmin) {
      return keyword ? `/search/${keyword}/page/${n}` : `/page/${n}`;
    }
    // keep current query string on admin list
    return `/admin/productlist/${n}${qs}`;
  };

  return (
    <Pagination>
      {Array.from({ length: pages }, (_, i) => i + 1).map((n) => (
        <Pagination.Item key={n} as={Link} to={makeHref(n)} active={n === page}>
          {n}
        </Pagination.Item>
      ))}
    </Pagination>
  );
};

export default Paginate;
